import React, {Suspense, useEffect, useState} from "react";
import ErrorBoundary from "../../utils/ErrorBoundary";
import {IItemContent} from "@connox/typescript-library";
import {useCustomerSelector} from "../../../store";
import {useTranslation} from "react-i18next";
import {paMainUrl, retrieveItemContent} from "./CrossSelling";
import {getPACustomerId} from "./RecommendationsPortal";
import {useCartContext} from "../../cart/CartContextProvider/CartContextProvider";
import SwiperConstruct, {BreakpointType} from "./SwiperConstruct";
import ListItemCard from "../productList/ListItemCard";
import {AddToCartButton} from "../../cart/AddToCartButton/AddToCartButtonPortal";

const BasketRecommendationsSwiperComponent: React.FC = () => {
  const [items, setItems] = useState<IItemContent[]>([]);
  const {customer} = useCustomerSelector();
  const {cart} = useCartContext();
  const {t} = useTranslation();

  useEffect(() => {
    const itemPositions = cart.positions.filter((pos) => pos.type === "Item" && !!pos.item && !!pos.reference?.itemId);
    // cart has no valid items
    if (!itemPositions.length) {
      return;
    }
    // https://docs.particularaudience.com/api-definitions/personalized-cart-page
    let paUrl = paMainUrl + "Cart?";
    const paCustomerId = getPACustomerId();
    if (paCustomerId) {
      paUrl += `customerId=${paCustomerId}&`;
    }

    paUrl += itemPositions.map((pos, index) => `items[${index}]=${pos.reference?.itemId ?? ""}`).join("&");
    paUrl += "&filterOutOfStock=false";
    void retrieveItemContent(paUrl, customer).then(setItems);
  }, []);

  if (!items.length) {
    return null;
  }

  const breakpoints: BreakpointType = {
    481: {
      slidesPerView: 2.5,
    },
    768: {
      slidesPerView: 3.5,
      slidesOffsetBefore: 16,
      slidesOffsetAfter: 16,
    },
    941: {
      slidesPerView: 4,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0,
    },
    1132: {
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0,
      slidesPerView: 4,
    },
  };

  return (
    <SwiperConstruct title={t("product.recommendationsForYou")} breakpoints={breakpoints}>
      {items.map((item, key) => (
        <React.Fragment key={key}>
          <ListItemCard item={item} />
          <AddToCartButton itemId={item.itemId} isSwiperAddToCartButton={true} />
        </React.Fragment>
      ))}
    </SwiperConstruct>
  );
};

const BasketRecommendationsSwiper: React.FC = () => {
  return (
    <ErrorBoundary fallback={null} occurrence="BasketRecommSwiper">
      <Suspense fallback={null}>
        <BasketRecommendationsSwiperComponent />
      </Suspense>
    </ErrorBoundary>
  );
};

export default BasketRecommendationsSwiper;
